import React, { createRef, useEffect, useState } from "react";
import add from "../../../images/icons/add.png";
import close from "../../../images/icons/close.png";
import edit from "../../../images/icons/edit.png";
import delete_icon from "../../../images/icons/delete.png";
import { Form, Formik } from "formik";
import CustomInput from "../../../components/CustomInput/CustomInput";
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import CustomButton from "../../../components/CustomButton/custombutton";
import * as Yup from "yup";
import { Box } from "@material-ui/core";
import Table from "../../../components/Table/Table";
import "./users.css";
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import apiUtil from "../../../api/apiUtil";
import api from "../../../api/api";
import getToken from "../../getToken";

const Users = () => {
  const refUserTable = createRef();
  const [showAddUsers, setShowAddUsers] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [detailUser, setDetailUser] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [adminType, setAdminType] = useState("admin");
  const handleAdminTypeChange = (event) => {
    setAdminType(event.target.value);
  };
  let roleListArray = [];

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    role: "",
    password: "",
  };

  const [usersList, setUsersList] = useState({
    isLoading: false,
    grouping: false,
    limit: 10,
    data: [],
    total: 0,
    page: 0,
  });

  function generateRandomString(length) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function generatePassword(setFieldValue) {
    const newPassword = generateRandomString(15);
    setFieldValue("password", newPassword);
  }

  const clickBtnClose = () => {
    setShowAddUsers(false);
    setIsEdit(false);
  };

  const clickAddUsers = () => {
    setShowAddUsers(true);
  };

  const clickEditUsers = (rowData) => {
    setDetailUser({
      userId: rowData.userID,
      name: rowData.name,
      email: rowData.email,
      phone: rowData.phoneNo,
      role: rowData.role,
      password: "",
    });
    setIsEdit(true);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  let brandId = localStorage.getItem("brandId");
  let branchId;

  if (brandId == "265f0dff-a30a-11ed-b26e-6045bdd63acb") {
    branchId = "8cd5fe32-a30a-11ed-b26e-6045bdd63acb";
    console.log("branchId: " + branchId);

  } else if (brandId == "e7615a4c-b9e4-11ee-93ac-902e16958ce1") {
    branchId = "734d09cf-b9e5-11ee-93ac-902e16958ce1";
    console.log("branchId: " + branchId);

  } else {
    branchId = "8c3d4a7a-699d-11ee-9653-902e16958ce1";
    console.log("branchId: " + branchId);
  }

  const paramRoleList = {
    brandId: brandId,
  };
  const retrieveRoleList = (value = paramRoleList) => {
    api
      .get("Admin/GetUserRoleList", paramRoleList, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setRoleList(
                response.data.data && response.data.data.length > 0
                  ? response.data.data
                  : []
              );
            } else {
              setRoleList({
                data: [],
                total: 0,
                page: 0,
                limit: 0,
                isLoading: false,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };
  for (const item in roleList) {
    roleListArray.push({
      label: roleList[item].name,
      value: roleList[item].id,
    });
  }

  const [paramUsers, setParamUsers] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    brandId: brandId,
    sortBy: "",
  });

  const AddUsersFormValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    email: Yup.string()
      .test("email", "Please enter the correct email address.", (val) =>
        apiUtil.emailValidation(val)
      )
      .required("Please enter the email address."),
    phone: Yup.number().required("Please enter the phone number."),
    role: Yup.string().required("Please select the role."),
    password: Yup.string().required("Please Generate Password")
      .test("len", "Password must be at least 8 characters.", (val) =>
        val && val.length >= 8
      ),
  });

  const retrieveUsersList = (value = paramUsers) => {
    value.keyword = keyword || "";
    setUsersList({
      ...usersList,
      isLoading: true,
    });
    api.post("Admin/GetAdminList", value, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setUsersList({
              isLoading: false,
              limit: response.data.data.rowLimit,
              data:
                response.data.data.data && response.data.data.data.length > 0
                  ? response.data.data.data
                  : [],
              total: response.data.data.totalRecords,
              page: response.data.data.paging,
            });
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          setUsersList({
            data: [],
            total: 0,
            page: 0,
            limit: 0,
            isLoading: false,
          });
        }
      );
    });
  };

  const handleSubmitEditUsersForm = (values, actions) => {
    const payload = {
      userId: values.userId,
      brandId: brandId,
      name: values.name,
      email: values.email,
      phone: values.phone,
      password: values.password,
      userRoleID: values.role,
    };
    api.post("Admin/UpdateAdminUser", payload, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response.data);

          if (response.data.statusCode === 200) {
            alert("Admin user updated successfully!!");

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setIsEdit(false);

            retrieveUsersList();
          } else if (response.data.statusCode === 401) {
            alert(response.data.value.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else {
            alert(response.data.message);
            console.log(response.data);
          }
        },
        (error, type) => {
          alert(error);
          values = {};
        }
      );
    });
    actions.setSubmitting(false);
  };

  const handleSubmitUsersForm = (values, actions) => {
    const payload = {
      userName: values.name,
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      phone: values.phone,
      email: values.email,
      userRoleId: values.role,
      password: values.password,
      brandId: brandId,
      branchId: branchId,
      adminType: adminType,
    };
    api
      .post("Admin/CreateAdminUserAccount", payload, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response.data);

            if (response.data.statusCode === 200) {
              alert("Admin user is created successfully!!");

              // reset the inputs and clear values
              actions.resetForm();
              values = {};
              setShowAddUsers(false);

              retrieveUsersList();
            } else if (response.data.statusCode === 401) {
              alert(response.data.value.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else {
              alert(response.data.message);
              console.log(response.data);
            }
          },
          (error, type) => {
            alert(error);
            values = {};
          }
        );
      });
    actions.setSubmitting(false);
  };

  const handleDelete = (row) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      api
        .post(
          `Admin/DeleteAdminUser?userID=${row.userID}&BrandId=${branchId}`, {}, getToken()
        )
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.code === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.statusCode === 200) {
                alert("Admin user deleted successfully!!");
                console.log(response.data);
                retrieveUsersList();
              } else {
                alert(response.data.message);
              }
            },
            (error, type) => {
              console.log(error);
            }
          );
        });
    };
  }

  useEffect(() => {
    retrieveRoleList();
    retrieveUsersList();
  }, [paramUsers]);

  return (
    // <div className="users container">
    //   <div className="row">

    <div className="users">
      {(showAddUsers || isEdit) && (
        <>
          <div className=" Actions space_between">
            <h6 className="title_text mt-2">
              {isEdit ? "Edit User" : "Add User"}
            </h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          <div>
            <Formik
              initialValues={isEdit ? detailUser : initialValues}
              validateOnBlur={false}
              validationSchema={AddUsersFormValidation}
              onSubmit={(values, actions) => {
                isEdit
                  ? handleSubmitEditUsersForm(values, actions)
                  : handleSubmitUsersForm(values, actions);
              }}
            >
              {({ values, errors, touched, setFieldValue }) => {
                return (
                  <Form className="row form-container add-user-form">
                    <h6 className="title_text mt-2">User Information</h6>
                    <div className="col-12">
                      <CustomInput
                        name="name"
                        type="text"
                        label="User Name"
                        customclass="input_wrapper"
                        hideicon="true"
                        placeholder="Enter Name"
                      />
                    </div>

                    {(showAddUsers) && (
                      <div className="input_wrapper d-flex flex-row my-2">
                        <label className="radio">
                          <input
                            type="radio"
                            value="admin"
                            checked={adminType === 'admin'}
                            onChange={handleAdminTypeChange}
                          />
                          Portal Admin
                        </label>
                        <label className="radio">
                          <input
                            type="radio"
                            value="mobileadmin"
                            checked={adminType === 'mobileadmin'}
                            onChange={handleAdminTypeChange}
                          />
                          Mobile Admin
                        </label>
                      </div>
                    )}

                    <div className="col-12 mt-2">
                      <CustomInput
                        name="email"
                        type="email"
                        label="Email"
                        customclass="input_wrapper"
                        hideicon="true"
                        placeholder="Enter Email"
                      />
                    </div>

                    <div className="col-12 mt-2">
                      <CustomInput
                        name="phone"
                        type="text"
                        label="Phone Number"
                        customclass="input_wrapper"
                        hideicon="true"
                        placeholder="Enter Phone Number"
                      />
                    </div>
                    <div className="col-10 mt-2 generate-password">
                      <CustomInput
                        name="password"
                        type="password"
                        label="Password"
                        customclass="input_wrapper"
                        hideicon="true"
                        placeholder="Password"
                      />
                    </div>
                    <div className="col-2 mt-2 btn-container">
                      <button
                        className="btn-generate-password"
                        onClick={() => generatePassword(setFieldValue)}
                        type="button"
                      >
                        Generate
                      </button>
                    </div>

                    <div className="col-12 mt-2">
                      <CustomSelect
                        options={roleListArray}
                        name="role"
                        label="Role"
                        isClearable={false}
                        placeholder="Select Role"
                      />
                    </div>

                    <div className="col-12 mt-3">
                      <div className="Actions justify-content-end">
                        <button
                          type="button"
                          className="button btnCancel"
                          onClick={clickBtnClose}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="button btnUpdate">
                          {showAddUsers ? "Create" : "Update"}
                        </button>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Users</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveUsersList()}
          />
          {!showAddUsers && (
            <CustomButton
              icon={add}
              text="Add Admin"
              addIcon={true}
              className="btnAdd"
              onClick={clickAddUsers}
            />
          )}
        </div>
      </div>

      <div className="table_container promotion_table">
        <Table
          key={usersList.total}
          ref={refUserTable}
          maxBodyHeight={usersList.limit * 100}
          isLoading={usersList.isLoading}
          grouping={usersList.grouping}
          limit={usersList.limit}
          page={usersList.page}
          total={usersList.total}
          data={usersList.data}
          onPageChange={(page) => {
            setParamUsers({
              ...paramUsers,
              currentPage: page,
            });
            retrieveUsersList(paramUsers);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex = (usersList.page - 1) * usersList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Name",
              field: "name",
              width: "231px",
            },
            {
              title: "Email",
              field: "email",
              width: "232px",
            },
            {
              title: "Phone Number",
              field: "phoneNo",
              width: "178px",
            },
            {
              title: "Role",
              render: (row) => {
                if (roleListArray.length > 0) {
                  let role = roleListArray.find(
                    (role) => role.value == row.role
                  );
                  return role ? role.label : "";
                }
                return "";
              },
              width: "136px",
              align: "center",
            },
            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => clickEditUsers(row)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleDelete(row)
                    }
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </div>
  );
};

export default Users;
